import { forwardRef, type SelectHTMLAttributes } from "react";

import { cx } from "../lib/format";

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options?: SelectOption[];
  invalid?: boolean;
  placeholder?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { options, invalid = false, placeholder, className, children, ...rest },
  ref,
) {
  return (
    <div className={cx("relative", className)}>
      <select
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cx(
          "h-9 w-full appearance-none rounded border bg-surface pl-3 pr-8 text-sm text-bright",
          "transition-colors focus:outline-none",
          invalid ? "border-danger" : "border-line focus:border-muted",
          "disabled:cursor-not-allowed disabled:opacity-50",
        )}
        {...rest}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options
          ? options.map((option) => (
              <option key={option.value} value={option.value} disabled={option.disabled}>
                {option.label}
              </option>
            ))
          : children}
      </select>
      <svg
        className="pointer-events-none absolute right-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
      >
        <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
});
